"use strict";
/* eslint-disable no-console */
Object.defineProperty(exports, "__esModule", { value: true });
exports.inspect = void 0;
/**
 * Inspects the value and returns it.
 */
function inspect(value, inspector = console.dir) {
    inspector(value);
    return value;
}
exports.inspect = inspect;
//# sourceMappingURL=inspect.js.map